<template>
  <nav class="footer-nav">
    <ul class="list-reset">
      <li>
        <router-link to="/about/">About</router-link>
      </li>
      <li>
        <router-link to="/guarantee/">Guarantee</router-link>
      </li>

      <li>
        <router-link to="/faq/">FAQs</router-link>
      </li>
      <li>
        <router-link to="/case-studies/">Case Studies</router-link>
      </li>

      <!-- <li>
        <router-link to="/articles/">Articles</router-link>
      </li>-->

      <li>
        <router-link to="/contact/">Contact</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "CFooterNav"
};
</script>
